export const getFileName = (str?: string) => {
  if (str && str?.length > 12) {
    return str.slice(0, 4) + '...' + str.slice(-6);
  } else return str;
};
